import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AdminUpdateUserMaxRunningArcsArgs {
  @Field(t => Int)
  userId!: number

  // How many review campaigns the account may have live at once: -1 for unlimited, or null to go
  // back to the plan's initial limit.
  @Field(t => Int, { nullable: true })
  maxRunningArcs?: number | null
}
